import React from 'react';
import { View, Image, Linking, ViewStyle } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Images } from '../../../assets';
import responsiveStyles from './styles';
import { AEM_API_BASE_URL } from '../../config/getEnvironmentVars';
import { Components, Theme } from '@oneamerica/dxp-ui-components';
import { trackCustomEvent } from '../../utils/Analytics/AdobeAnalyticsUtils';
import { analyticsTags } from '../../utils/Analytics/AnalyticsTags';

const GuestHeader = () => {
  const { top } = useSafeAreaInsets();
  const topInset = top ?? 0;
  const styles = responsiveStyles(topInset);

  const renderOALogo = () => {
    return (
      <Components.Link
        accessibilityLabel="One America Financial logo"
        accessibilityRole="button"
        onPress={() => {
          trackCustomEvent(analyticsTags.CaptureOAFinancialGuestHeaderlogoTags);
          openURL(AEM_API_BASE_URL);
        }}
        testID="guestHeader:logo"
        focusStyle={
          {
            outlineWidth: 1,
            outlineColor: Theme.Color.ice4,
            outlineStyle: 'solid',
            outlineOffset: 1,
            padding: 0,
          } as ViewStyle
        }
      >
        <Image
          source={Images.oaLogo}
          alt="OneAmerica Financial logo"
          style={{
            width: 159,
            height: 40,
          }}
          resizeMode="contain"
        />
      </Components.Link>
    );
  };

  const openURL = (url) => {
    //@ts-ignore
    Linking.openURL(url, '_self').catch((err) =>
      console.error('An error occurred', err),
    );
  };

  return (
    <View testID="guestHeader" className="w-full z-50">
      {/* Blue Bar on Top */}
      <View
        className="w-full py-1 px-5 flex-row items-center justify-between md:h-[50px]"
        style={styles.infoHeader}
      ></View>

      {/* White Bar with Logo */}
      <View
        className={`w-full bg-white h-[${
          topInset + 60
        }px] md:border-t-0 md:h-[92px] px-6 lg:px-8 py-2.5 md:py-0`}
        style={styles.header}
        pointerEvents="box-none"
      >
        <View
          className="w-full flex-row justify-between max-w-[1250px] mx-auto h-full items-center"
          pointerEvents="box-none"
        >
          <View className="flex-row flex-1 items-center">{renderOALogo()}</View>
        </View>
      </View>
    </View>
  );
};

export default GuestHeader;
